import "./ConstructionProcess.css";

const ProcessStep = ({ process }) => {
  const Icon = process.icon;

  return (
    <div className="process-card">
      <div className="step-number">{process.step}</div>

      <div className="process-icon">
        <Icon />
      </div>

      <h3>{process.title}</h3>

      <p>{process.description}</p>
    </div>
  );
};

export default ProcessStep;
